module.exports = __webpack_public_path__ + "static/media/k.daca1ab9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/k.mp3
// module id = 100
// module chunks = 0